export default __webpack_public_path__ + "static/media/2595.e5e9c137.png";